import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        _createElementVNode("div", {
          class: "o-text",
          innerHTML: $props.field.RedactorContent
        }, null, 8 /* PROPS */, _hoisted_2)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}